import IconActionButton from "./IconActionButton";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";

const SellIconButton = ({title, disabled = false, onClick}) => (
    <IconActionButton
        title={title}
        onClick={onClick}
        disabled={disabled}
        className="text-indigo-700 ml-2"
    >
        <SellOutlinedIcon fontSize="small"/>
    </IconActionButton>
);

export default SellIconButton;